import React from 'react';
import { FileText, Zap, MapPin, ShieldCheck } from 'lucide-react';
export function TopBar() {
  return <div className="w-full bg-brand-green border-b border-gold/20 py-2 px-4 sticky top-0 z-50" data-id="element-357">
      
    </div>;
}